/**
 * Toast utilities for Dev Workbench
 *
 * This module provides a hook-based toast API for use in Dev Workbench components.
 * Uses the global ToastContext from the app.
 */

import { useToast } from '../../../hooks';

/**
 * Hook to get toast helper functions for Dev Workbench
 *
 * @returns {Object} Toast helper functions
 */
export function useWorkbenchToast() {
  const toast = useToast();

  return {
    /**
     * Show a success toast
     * @param {string} message - Message to display
     */
    success: (message) => toast.success(message, { duration: 2000 }),

    /**
     * Show an error toast
     * @param {string} message - Message to display
     */
    error: (message) => toast.error(message, { duration: 4000 }),

    /**
     * Show a "Copied to clipboard" toast
     */
    copied: () => toast.success('Copied to clipboard', { duration: 1500 }),
  };
}
